// extracted by mini-css-extract-plugin
export default {"wrapper":"ApartmentOrganizationCard_wrapper__58lxj"};